/** Format a Date as YYYY-MM-DD in the *local* timezone (never UTC/`toISOString`). */
export function formatLocalDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Today's local calendar date as YYYY-MM-DD. */
export function localTodayString(): string {
  return formatLocalDate(new Date());
}

export const getDateRangeObject = (
  value: string
): { start_date: string; end_date: string } | null => {
  const today = new Date();
  const format = formatLocalDate;

  const startOfWeek = () => {
    const d = new Date(today);
    const day = d.getDay(); // 0 = Sunday
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    d.setDate(diff);
    return d;
  };

  const startOfMonth = () => new Date(today.getFullYear(), today.getMonth(), 1);

  switch (value) {
    case 'Today': {
      const d = format(today);
      return { start_date: d, end_date: d };
    }
    case 'Yesterday': {
      const d = new Date(today);
      d.setDate(d.getDate() - 1);
      const y = format(d);
      return { start_date: y, end_date: y };
    }
    case '7DAYS': {
      const start = new Date(today);
      start.setDate(start.getDate() - 6);
      return { start_date: format(start), end_date: format(today) };
    }
    case '30DAYS': {
      const start = new Date(today);
      start.setDate(start.getDate() - 29);
      return { start_date: format(start), end_date: format(today) };
    }
    case 'This_Week': {
      const start = startOfWeek();
      return { start_date: format(start), end_date: format(today) };
    }
    case 'This_Month': {
      const start = startOfMonth();
      return { start_date: format(start), end_date: format(today) };
    }
    case 'All_Time': {
      return null;
    }
    default: {
      const slashParts = value?.split(' / ');
      if (slashParts && slashParts.length === 2) {
        const [start, end] = slashParts;
        if (start?.length === 10 && end?.length === 10) {
          return { start_date: start, end_date: end };
        }
      }
      return null;
    }
  }
};
